import none from '../../img/kandokLogo.jpg'

export const appetizer = [
 {
  "id": 31,
  "title": "سیب زمینی ویژه کوچک",
  "desciption": "سیب زمینی سرخ شده،پنیرپیتزا،ژامبون گوشت",
  "price": 130,
  "image": none
 },
 {
  "id": 32,
  "title": "سیب زمینی ویژه بزرگ",
  "desciption": "سیب زمینی سرخ شده،پنیرپیتزا، ژامبون گوشت",
  "price": 180,
  "image": none
 },
 {
  "id": 33,
  "title": "سیب زمینی ساده کوچک",
  "price": 90,
  "image": none
 },
 {
  "id": 34,
  "title": "سیب زمینی ساده بزرگ",
  "price": 140,
  "image": none
 },
 {
  "id": 35,
  "title": "میرزا قاسمی",
  "price": 100,
  "image": none
 },
 {
  "id": 36,
  "title": "کشک بادمجان",
  "price": 100,
  "image": none
 }
]